<template>
    <!-- 上传附件 -->
    <div class="wk-input-uploader wk-input-box">
        <span class="input-left-label">{{labelOver}}</span>
        <div class="posi-relative">
            <input-base :type="type" v-model="inputVal" :initVal="value" :placeholder="placeholderOver" />
            <!-- 上传按钮 -->
            <div class="posi-absolute flex">
                <img src="../../assets/img/sctp_jt.png">
                <van-uploader :after-read="onRead">
                    <van-icon name="photograph" />
                </van-uploader>
            </div>
        </div>
    </div>
</template>
 
<script>
    export default {
        name: 'inputlsit',
        props: ['label','upName','type','upSuccTip','value','placeholder','maxlength'],
        mounted(){
            if(this.label){
                this.labelOver = this.label;
            }
            //提示
            if(this.placeholder){
                this.placeholderOver =  this.placeholderOver + this.placeholder;
            }else if(this.label){
                this.placeholderOver =  this.placeholderOver + this.label;
            }
        },
        watch:{
            inputVal(){
                this.$emit('input',this.inputVal)
            }
        },
        data(){
            return{
                inputVal:'',
                labelOver:'',
                placeholderOver:''
            }
        },
        methods:{
            onRead(file){
                let fileObj = {
                    files:file.file,
                    upName:this.upName,
                    upSuccTip:this.upSuccTip
                }
                this.$emit('upBack',fileObj)
            }
        }
    }
</script>
<style lang="less" scoped>
    .wk-input-uploader{
        margin:.9rem 0;
        >div{
            >div{
                top:0;
                right:-5.5rem;
                line-height: 2.1rem;
                padding:0 .5rem;
                border:.05rem solid #d1d1d1;
                color:#003399;
                cursor: pointer;
                img{
                    width:0.9rem;
                    height:0.9rem;
                    margin:.6rem .3rem 0 0;
                }
            }
        }   
    }
</style>



// WEBPACK FOOTER //
// src/components/BaseCpts/wkInputUploader.vue